import { useRef, useLayoutEffect } from "react"
import { useWatchVariations, mvSubscribe } from "./../context"
import { useDictionary } from "contexts/Dictionary"
import { KILL_ROUTE } from "./../constants"
import Link from "components/link/Link"
import { useActive } from "./../hooks"
import { Main } from "./styles"
import styled from "@emotion/styled"
import { Loader } from "./../Loader"
import { useNavigation } from "contexts/Navigation"
const StyledButton = styled(Link)`
  pointer-events: auto;
`

export function Bottom({ ctx, is_entry = false }) {
  const { active, wactive, entry, wentry, route, fromui, sticky, gready, wa, kill } = useWatchVariations(ctx)
  const viewlink = useActive(is_entry ? wentry : wactive)
  const rfmain = useRef(null)
  const dictionary = useDictionary()
  const navigation = useNavigation()

  function onRoute(v) {
    display(v && v !== KILL_ROUTE)
  }

  function display(v) {
    rfmain.current?.classList[v ? "add" : "remove"]("wv_reveal")
    if (!v) {
      onSticky(false)
      rfmain.current?.classList.remove("wv_ready")
    } else onSticky(sticky.get())
  }

  function redirect(e) {
    if (is_entry) {
      e.preventDefault()
      return kill()
    }
    if (active.get() === entry.get()) {
      fromui.set(true)
      route.set(KILL_ROUTE)
      e.preventDefault()
    }
    wa({}, true, is_entry || active.get() === entry.get())
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])

  function onSticky(v) {
    rfmain.current?.classList[v ? "add" : "remove"]("wv_sticky")
  }

  function onGready(v) {
    if (!v || !route.get()) return
    rfmain.current?.classList.add("wv_ready")
  }

  useLayoutEffect(() => mvSubscribe("Bottom sticky", sticky, onSticky), [])
  useLayoutEffect(() => mvSubscribe("Bottom gready", gready, onGready), [])
  /*
    useLayoutEffect(() => {
      const el = rfmain.current?.querySelector("a")
      if (!el) return
      el.addEventListener("click", redirect, false)
  
      return () => {
        el.removeEventListener("click", redirect, false)
      }
    }, [])
  */
  function onDiscover(e) {
    e.preventDefault()
    wa({}, true, is_entry || active.get() === entry.get())
    navigation.navigate(e.target.getAttribute("href"))
  }

  return (
    <Main ref={rfmain}>
      <StyledButton href={viewlink} className={`${is_entry ? "wvFocusRef" : "wvFocus"} filled opaque-green`} icon='none' onClick={onDiscover}>
        {dictionary.discover()}
      </StyledButton>
      <Loader ctx={ctx} size={20} color='#ff0000' />
    </Main>
  )
}
